var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-fade",attrs:{"role":"dialog","data-testid":_vm.testId}},[_c('div',{class:{
      'white-container': true,
      wide: _vm.wide,
      high: _vm.high,
      [`width-${this.width}`]: true,
      'close-hidden': _vm.noCloseButton,
    }},[(!_vm.noCloseButton)?_c('button',{staticClass:"icon-close close-the-modal",attrs:{"data-testid":"modalCloseBtn"},on:{"click":function($event){$event.preventDefault();return _vm.handleClose.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),(_vm.heading)?_c('h2',[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_vm._t("default")],2),_vm._v(" "),(_vm.line)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.$slots.buttons)?_c('div',{class:{
        'modal-actions': true,
        'space-between': _vm.justifyModalActions === 'space-between',
        center: _vm.justifyModalActions === 'center',
      }},[_vm._t("buttons")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }